import React from 'react';
import { Link } from 'react-router-dom';
import { getHoverRingClass } from '../../config/partners';

const baseClass =
  'flex flex-col items-center justify-center bg-white rounded-xl ring-2 ring-gray-200 transition-all duration-300 shadow-sm hover:shadow-md';

/**
 * Renders a partner logo card. Uses config partner object and optional className for size variant.
 * @param {Object} partner - from getPartnersByKeys() / PARTNERS
 * @param {string} [className] - extra classes e.g. p-8 min-h-[220px] w-full md:max-w-sm
 * @param {string} [logoClassName] - override partner.logoClass for compact variant
 */
const PartnerCard = ({ partner, className = '', logoClassName }) => {
  const hoverClass = getHoverRingClass(partner.hoverRing);
  const cardClasses = `${baseClass} ${hoverClass} ${className}`.trim();
  const imgClass = logoClassName ?? partner.logoClass;

  const content = (
    <>
      <img
        src={partner.logo}
        alt={partner.displayName || partner.name}
        className={imgClass}
      />
      <span className="text-base font-semibold text-gray-900 text-center">
        {partner.displayName || partner.name}
      </span>
    </>
  );

  if (partner.isInternal) {
    return (
      <Link to={partner.link} className={cardClasses}>
        {content}
      </Link>
    );
  }

  return (
    <a
      href={partner.link}
      target="_blank"
      rel="noopener noreferrer"
      className={cardClasses}
    >
      {content}
    </a>
  );
};

export default PartnerCard;
